export const SUPPORTED_LANGUAGES = [
  "ja",
  "en",
  "zh",
]
